<template>
    <div class="animated fadeIn">
        <b-container>
            <b-row>
                <b-col>
                    <b-input-group>
                        <b-form-input
                            size="lg"
                            :placeholder="$t('text.searchPlaceHolder')"
                            ref="search"
                            v-model="searchString"
                            @keyup.enter.native="triggerSearch"
                        />
                        <b-btn
                            slot="append"
                            variant="primary"
                            :disabled="resultLoading"
                            @click="triggerSearch"
                        >
                            <b style="font-size: 18px">
                                <i
                                    class="icon-magnifier icon-large"
                                    v-if="!resultLoading"
                                />
                                <i
                                    class="fa fa-spinner fa-spin"
                                    v-if="resultLoading"
                                ></i>
                            </b>
                        </b-btn>
                    </b-input-group>
                    <!-- <hr style="visibility: hidden"/> -->
                </b-col>
            </b-row>
            <b-row v-if="!!searchResult">
                <b-col
                    sm="12"
                    md="6"
                    v-for="user in searchResult.users"
                    :key="user"
                    class="animated fadeIn"
                >
                    <b-card no-body>
                        <b-card-body>
                            <h4 class="float-left">
                                <router-link
                                    :to="{
                                        name: 'user',
                                        params: { id: user.id },
                                    }"
                                    >{{ user.name }}</router-link
                                >
                            </h4>
                            <b-badge class="float-right" variant="light" pill>{{
                                user.title
                            }}</b-badge>
                            <b-badge class="float-right" variant="light" pill>{{
                                user.company.name
                            }}</b-badge>
                            <ul class="vcard" style="clear: both">
                                <li v-if="user.email">
                                    <i class="fa fa-envelope" />
                                    {{ user.email }}
                                </li>
                                <li v-if="user.mobile_phone">
                                    <i class="fa fa-phone" />
                                    {{ user.mobile_phone }}
                                </li>
                                <li v-if="user.office_phone">
                                    <i class="fa fa-phone" />
                                    {{ user.office_phone }}
                                </li>
                            </ul>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            <b-row> </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    // props: {
    //   searchString: {
    //     type: String,
    //     default: ""
    //   }
    // },

    data() {
        return {
            searchString:
                this.$route.params.query == null
                    ? ''
                    : this.$route.params.query,
            resultLoading: false,
            searchResult: [],
        }
    },
    mounted() {
        // console.log('instance', this)
        this.$refs.search.focus()
        this.triggerSearch()
    },
    methods: {
        triggerSearch() {
            if (this.resultLoading || this.searchString.length < 3) {
                return
            }

            this.resultLoading = true
            let response = response.then(this.processResponse).finally(() => {
                this.resultLoading = false
            })
        },

        processResponse(response) {
            let data = response.data

            let companies = this.getCompaniesFromData(data)
            let departments = this.getDepartmentsFromData(data)

            this.searchResult = {
                users: data,
                departments: departments,
                companies: companies,
            }
        },

        // Todo: Refactor into 1 method
        getCompaniesFromData(data) {
            let companies = data.reduce((companies, user) => {
                companies[user.company.id] = user.company
                return companies
            }, {})
            return Object.values(companies)
        },

        getDepartmentsFromData(data) {
            let departments = data.reduce((departments, user) => {
                departments[user.department.id] = user.department
                return departments
            }, {})
            return Object.values(departments)
        },
    },
}
</script>
<style>
.vcard {
    padding: 0;
    margin: 0;
    list-style: none;
}
.vcard li {
    list-style: none;
}
</style>
